module.exports = __webpack_public_path__ + "static/media/signature.e6399e4e.png";